// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";

// const OrderConfirmDynamic = () => {
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const location = useLocation();
//   const navigate = useNavigate();

//   // const orderId = location.state?.order_id;
//   const orderId =
//   location.state?.orderId || localStorage.getItem("last_order_id");

//   const userId = sessionStorage.getItem("userId");

//   const razorpayPaymentId = location.state?.razorpay_payment_id;

//   // ================= FETCH ORDER =================
//   const fetchOrder = async () => {
//     try {
//       const res = await axios.post(
//         "https://ecom.cyberathon.com/index.php/Api/list_new_order",
//         {
//           user_id: userId,
//           order_id: orderId,
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       if (res.data?.status && res.data?.orders?.length > 0) {
//         setOrder(res.data.orders[0]);
//       } else {
//         setOrder(null);
//       }
//     } catch (error) {
//       console.error("Order fetch error:", error);
//       setOrder(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= EFFECT =================
//   useEffect(() => {
//     if (!userId) {
//       navigate("/");
//       return;
//     }

//     if (!orderId) {
//       navigate("/");
//       return;
//     }

//     fetchOrder();
//   }, [userId, orderId]);

//   // ================= UI STATES =================
//   if (loading) {
//     return <p style={{ textAlign: "center" }}>Loading order details...</p>;
//   }

//   if (!order) {
//     return <p style={{ textAlign: "center" }}>Order not found.</p>;
//   }

//   // ================= UI =================
//   return (
//     <div className="confirm-container">
//       <div className="confirm-box">
//         <div className="check-icon ">
//           {/* <i class="bi bi-check-lg fs-1 check-icon1"></i> */}
          
//           <div className=""><img src="/Images/checkedimg.jpg" className="check-icon1"/></div>
//           </div>
//         <h2 className="confirm-title">Order Confirmed</h2>

//         <p className="confirm-text">
//           Your order <b className="text-success ">#{order.order_number}</b> has been placed successfully.
//         </p>

//         <div className="delivery-box">
//           <div className="left">
//             <p>
//               <b>Delivering to:</b><br />
//               {/* {order.first_name} {order.last_name}<br /> */}
//               {/* {order.address1}, {order.city}, {order.state} - {order.pin_code} */}
//               {order.billing_details?.first_name}{" "}
//               {order.billing_details?.last_name}<br />
//               {order.billing_details?.address1},{" "}
//               {order.billing_details?.city},{" "}
//               {order.billing_details?.state} -{" "}
//               {order.billing_details?.pin_code}
//             </p>

//             <p><b>Payment Mode:</b> {order.payment_mode}</p>

//                         {/* ✅ Show Razorpay Payment ID if available */}
//             {razorpayPaymentId && (
//               <p>
//                 <b>Payment ID:</b>{" "}
//                 <span className="text-success">{razorpayPaymentId}</span>
//               </p>
//             )}
            
//             <p><b>Order Status:</b> {order.order_status}</p>
//             <p><b>Total Amount:</b><span className="text-success fw-semibold"> ₹{order.total}</span></p>

//             {/* <div className="order-confirmed-btn">
//               <Link to="/orderlist">ORDER DETAILS</Link>
//             </div> */}
//           </div>

//           <div className="right">
//             <img src="/Images/delieveryimg.png" alt="Delivery" className="delievimg"/>
//           </div>
//         </div>

//         <div className="order-confirm-button-row d-flex justify-content-center align-items-center gap-5">
//           <Link to="/products">
//             <button className="bg-col border-0 rounded-1 p-2 text-light fw-semibold">
//               CONTINUE SHOPPING
//             </button>
//           </Link>

//           <Link to="/orderlist">
//             <button className="bg-col border-0 rounded-1 p-2 text-light fw-semibold">
//               VIEW ORDER
//             </button>
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrderConfirmDynamic;
















import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com";

const OrderConfirmDynamic = () => {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  const orderId =
    location.state?.orderId || localStorage.getItem("last_order_id");

  const userId = sessionStorage.getItem("userId");
  const razorpayPaymentId = location.state?.razorpay_payment_id;

  // ================= FETCH ORDER =================
  const fetchOrder = async () => {
    try {
      const res = await axios.post(
        `${BASE_URL}/index.php/Api/list_new_order`,
        {
          user_id: userId,
          order_id: orderId,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data?.status && res.data?.orders?.length > 0) {
        const orderData = res.data.orders[0];

        // Agar items string hai toh parse karo
        if (typeof orderData.items === "string") {
          try {
            orderData.items = JSON.parse(orderData.items);
          } catch (e) {
            orderData.items = [];
          }
        }

        // Agar items null ya undefined hai toh empty array
        if (!Array.isArray(orderData.items)) {
          orderData.items = [];
        }

        setOrder(orderData);
      } else {
        setOrder(null);
      }
    } catch (error) {
      console.error("Order fetch error:", error);
      setOrder(null);
    } finally {
      setLoading(false);
    }
  };

  // ================= EFFECT =================
  useEffect(() => {
    if (!userId) {
      navigate("/");
      return;
    }

    if (!orderId) {
      navigate("/");
      return;
    }

    fetchOrder();
  }, [userId, orderId]);

  // ================= HELPER: Format Pack Type =================
  // const getPackLabel = (item) => {
  //   if (item.price_type === "quantity_set" && item.selected_quantity_set) {
  //     if (typeof item.selected_quantity_set === "object") {
  //       return item.selected_quantity_set.label || 
  //              item.selected_quantity_set.name || 
  //              `${item.selected_quantity_set.quantity || ""} Pc`;
  //     }
  //     return String(item.selected_quantity_set);
  //   }
  //   return null;
  // };


    // ================= HELPER: Format Pack Type =================
  const getPackLabel = (item) => {
    if (item.price_type === "quantity_set" && item.selected_quantity_set) {
      let parsed = item.selected_quantity_set;

      // ✅ FIX: String ho toh parse karo
      if (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch {
          return null;
        }
      }

      if (typeof parsed === "object" && parsed !== null) {
        return parsed.label || parsed.name || `${parsed.quantity || ""} Pc`;
      }

      return null;
    }
    return null;
  };

  

  // ================= HELPER: Get Image URL =================
  const getImageUrl = (product_image) => {
    if (!product_image) return null;

    // Case 1: Array
    if (Array.isArray(product_image)) {
      if (product_image.length === 0) return null;
      const img = String(product_image[0]);
      return img.startsWith("http") ? img : `${BASE_URL}/${img}`;
    }

    // Case 2: String
    if (typeof product_image === "string") {
      return product_image.startsWith("http")
        ? product_image
        : `${BASE_URL}/${product_image}`;
    }

    return null;
  };

  // ================= UI STATES =================
  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading order details...</p>;
  }

  if (!order) {
    return <p style={{ textAlign: "center" }}>Order not found.</p>;
  }

  // ================= UI =================
  return (
    <div className="confirm-container">
      <div className="confirm-box">
        <div className="check-icon">
          <div>
            <img src="/Images/checkedimg.jpg" className="check-icon1" alt="checked" />
          </div>
        </div>

        <h2 className="confirm-title">Order Confirmed</h2>

        <p className="confirm-text">
          Your order <b className="text-success">#{order.order_number}</b> has been placed successfully.
        </p>

        {/* ★★★ ORDER ITEMS SECTION ★★★ */}
        {order.items && order.items.length > 0 && (
          <div
            className="border rounded-3 p-3 mb-3"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <h6 className="fw-bold mb-3">
              <i className="bi bi-bag-check me-2"></i>Order Items
            </h6>

            {order.items.map((item, index) => {
              const packLabel = getPackLabel(item);
              const itemImage = getImageUrl(item.product_image);

              return (
                <div
                  key={index}
                  className="d-flex align-items-center gap-3 border-bottom py-2"
                >
                  {/* Product Image */}
                  {itemImage && (
                    <img
                      src={itemImage}
                      alt={item.product_name}
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    />
                  )}

                  {/* Product Details */}
                  <div className="flex-grow-1">
                    <div className="fw-semibold">{item.product_name}</div>

                    <div className="d-flex flex-wrap gap-2 mt-1">
                      {/* Pack Type Badge */}
                      {packLabel && (
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#24aeb1",
                            color: "#fff",
                            fontSize: "0.75rem",
                          }}
                        >
                          📦 {packLabel}
                        </span>
                      )}

                      {/* Size Badge */}
                      {item.size_id && (
                        <span
                          className="badge bg-secondary"
                          style={{ fontSize: "0.75rem" }}
                        >
                          Size: {item.size_id}
                        </span>
                      )}

                      {/* Simple badge */}
                      {!packLabel && !item.size_id && (
                        <span
                          className="badge bg-light text-dark"
                          style={{ fontSize: "0.75rem" }}
                        >
                          Simple
                        </span>
                      )}
                    </div>

                    <small className="text-muted">
                      ₹{item.price} × {item.qty}
                    </small>
                  </div>

                  {/* Subtotal */}
                  <div className="text-end">
                    <b className="text-success">₹{item.subtotal}</b>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="delivery-box">
          <div className="left">
            <p>
              <b>Delivering to:</b>
              <br />
              {order.billing_details?.first_name}{" "}
              {order.billing_details?.last_name}
              <br />
              {order.billing_details?.address1},{" "}
              {order.billing_details?.city},{" "}
              {order.billing_details?.state} -{" "}
              {order.billing_details?.pin_code}
            </p>

            <p>
              <b>Payment Mode:</b> {order.payment_mode}
            </p>

            {razorpayPaymentId && (
              <p>
                <b>Payment ID:</b>{" "}
                <span className="text-success">{razorpayPaymentId}</span>
              </p>
            )}

            <p>
              <b>Order Status:</b> {order.order_status}
            </p>

            {/* Price Breakdown */}
            {order.subtotal != null && (
              <div className="mt-2" style={{ fontSize: "0.9rem" }}>
                <div className="d-flex justify-content-between">
                  <span>Subtotal:</span>
                  <span>₹{order.subtotal}</span>
                </div>
                {order.shipping_price > 0 && (
                  <div className="d-flex justify-content-between">
                    <span>Shipping:</span>
                    <span>₹{order.shipping_price}</span>
                  </div>
                )}
                {order.discount > 0 && (
                  <div className="d-flex justify-content-between text-success">
                    <span>Discount:</span>
                    <span>- ₹{order.discount}</span>
                  </div>
                )}
                <hr className="my-1" />
                <div className="d-flex justify-content-between fw-bold">
                  <span>Total Amount:</span>
                  <span className="text-success">₹{order.total}</span>
                </div>
              </div>
            )}

            {/* Fallback */}
            {order.subtotal == null && (
              <p>
                <b>Total Amount:</b>
                <span className="text-success fw-semibold"> ₹{order.total}</span>
              </p>
            )}
          </div>

          <div className="right">
            <img
              src="/Images/delieveryimg.png"
              alt="Delivery"
              className="delievimg"
            />
          </div>
        </div>

        <div className="order-confirm-button-row d-flex justify-content-center align-items-center gap-5">
          <Link to="/products">
            <button className="bg-col border-0 rounded-1 p-2 text-light fw-semibold">
              CONTINUE SHOPPING
            </button>
          </Link>

          <Link to="/orderlist">
            <button className="bg-col border-0 rounded-1 p-2 text-light fw-semibold">
              VIEW ORDER
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmDynamic;